export const MAXIMUM_FILE_SIZE_MB = 20;
export const GLOBAL_SUCCESS_TOAST_ID = "global-success-toast";
export const GLOBAL_ERROR_TOAST_ID = "global-error-toast";
export const GLOBAL_UPLOADING_TOAST_ID = "global-uploading-toast";
